import { message } from 'antd';
import { DvIntlMessages } from '../components/utility/dvGeneralUtilities';
import moment from 'moment';
import {map} from 'lodash';

export const DATE_FORMAT = "YYYY-MM-DD";
export const DISPLAY_DATE_FORMAT = "DD/MM/YYYY";
export const DISPLAY_FULL_DATE_FORMAT = "dddd DD MMMM YYYY";
export const DISPLAY_DATE_TIME_FORMAT = "DD/MM/YYYY HH:mm:ss";
export const DEBOUNCE_TIME = 500; //milliseconds
export const DEBOUNCE_TIME_SHORT = 100; //milliseconds
export const TIME_FORMAT = "HH:mm";
export const MODAL_BODY_MIN_HEIGHT = 348;

export function isExpirationLocalStorageValueConsideredValid() {
  const tokenExpiresAt = getLocalStorageValue('tokenExpiresAt');
  if (tokenExpiresAt && moment(Number(tokenExpiresAt)).subtract(1, 'hour').isAfter(moment())) {
    return true;
  }
  return false;
}
export function clearTokenFromLocalStorage() {
  localStorage.removeItem('token');
  localStorage.removeItem('tokenExpiresAt');
}

export function getLocalStorageValue(key) {
  try {
    const value = localStorage.getItem(key);
    if (value === 'true') return true;
    if (value === 'false') return false;
    return value;
  } catch (error) {
    message.error(DvIntlMessages('error.getItemFromLocalStorage: ' + error));
  }
}

export function setLoginResultsToLocalStorage(token, tokenExpiresAt) {
  localStorage.setItem('token', token);
  localStorage.setItem('tokenExpiresAt', tokenExpiresAt);
}

export function removeLocalStorageItem(key) {
  localStorage.removeItem(key);
}

export function setLocalStorageItem(key, value) {
  localStorage.setItem(key, value);
}

export function getSessionStorageValue(key) {
  try {
    const value = sessionStorage.getItem(key);
    // return new Map({value});
    return value;
  } catch (error) {
    message.error(DvIntlMessages('error.getItemFromSessionStorage: ' + error));
  }
}

export const loadState = () => {
  try {
    const serializedState = sessionStorage.getItem('state');
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (error) {
    return undefined;
  }
}

export function timeDifference(givenTime) {
  givenTime = new Date(givenTime);
  const milliseconds = new Date().getTime() - givenTime.getTime();
  const numberEnding = number => {
    return number > 1 ? 's' : '';
  };
  const number = num => num > 9 ? '' + num : '0' + num;
  const getTime = () => {
    let temp = Math.floor(milliseconds / 1000);
    const years = Math.floor(temp / 31536000);
    if (years) {
      const month = number(givenTime.getUTCMonth() + 1);
      const day = number(givenTime.getUTCDate());
      const year = givenTime.getUTCFullYear() % 100;
      return `${day}-${month}-${year}`;
    }
    const days = Math.floor((temp %= 31536000) / 86400);
    if (days) {
      if (days < 28) {
        return days + ' day' + numberEnding(days);
      } 
        const months = [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec',
        ];
        const month = months[givenTime.getUTCMonth()];
        const day = number(givenTime.getUTCDate());
        return `${day} ${month}`;
    }

    const hours = Math.floor((temp %= 86400) / 3600);
    if (hours) {
      return `${hours} hour${numberEnding(hours)} ago`;
    }
    const minutes = Math.floor((temp %= 3600) / 60);
    if (minutes) {
      return `${minutes} minute${numberEnding(minutes)} ago`;
    }
    return 'a few seconds ago';
  };
  return getTime();
}

// baseColorInHex example #FFAAFF
// return hex string
export function getHighContrastColor(baseColorInHex) {
		let rgb = baseColorInHex ? hexToRgb(baseColorInHex) : {r: 10, g: 10, b: 10};
    
    let o = Math.round(((rgb.r * 299) +
        (rgb.g * 587) +
        (rgb.b * 114)) / 1000);
    let fore = (o > 125) ? '#262626' : '#FFFFFF';

    return fore;
}

// hex example #0033ff
export function hexToRgb(hex) {
    let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
}

export function getRanges(array) {
  let ranges = [], rstart, rend;
  for (let i = 0; i < array.length; i++) {
    rstart = array[i];
    rend = rstart;
    while (array[i + 1] - array[i] === 1) {
      rend = array[i + 1]; // increment the index if the numbers sequential
      i++;
    }
    ranges.push(rstart === rend ? rstart+'' : rstart + '-' + rend);
  }
  return ranges;
}

export function cleanObject(objectToClean) {
  /**
   * remove undefined/nulls and return the object
   */
  let cleanObject = {};

  for (const [key, value] of Object.entries(objectToClean)) {
    if (value !== undefined && value !== null) {
      cleanObject[key] = value;
    }
  }

  return cleanObject;
}


export function deepCompareObjects(obj1, obj2) {
  /**
   * checks if the objects are different
   */
  return obj1 && (JSON.stringify(obj1) !== JSON.stringify(obj2)) ;
}

export function removeObjectFromArray(arrayWithObjects, attributeForCheck, attributeValue) {
  /**
   * given an array of objects 
   * filter the array based on the object field 
   * that will be used for the
   * comparison and then return the new array.
   */
  
  return arrayWithObjects.filter(item => item[attributeForCheck] !== attributeValue);
}

export const getRandomColor = () => {
  const hexChars = "23456789ABD";

  return `#${Array.from({ length: 6 })
    .map(() => hexChars[Math.floor(Math.random() * 11)])
    .join("")}`;
};

export function removeTags(string) {
  if (!string) return string;
  return string.replace(/<\/?[^>]+(>|$)/g, "").replace("<br /> ", "");
}

export function normalizeString(string) {
  return string.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

// export function controlWithHighlight(textToHighlight, searchQuery) {
//   if (!textToHighlight) textToHighlight = "";
//   if (React.isValidElement(textToHighlight)) return textToHighlight;
  
//   let searchWords = [];
//   if (searchQuery) {
//     searchWords = normalizeString(searchQuery).split(' ');
//   }
//   return (<Highlighter
//     searchWords={searchWords}
//     autoEscape={true}
//     textToHighlight={textToHighlight}
//     sanitize={normalizeString}
//     highlightClassName="hightlight-mark"
//   />);
// } 

export function replaceUndefinedWithNulls(item) {
  let newItem = {}
  for (const [key, value] of Object.entries(item)) {
    if (value !== undefined) {
      newItem[key] = value;
    } else {
      newItem[key] = null;
    }
  }

  return newItem;
}

export function isObjectEmpty(objectToCheck) {
  return objectToCheck === null || objectToCheck === undefined || Object.keys(objectToCheck).length === 0;
}

export function getRandomHex() {
  return '#'+Math.random().toString(16).substr(-6);
}

// export function getRawTextFromDraftJsHtml(htmlBody) {
//   if (!htmlBody.length) return null;
//   const htmlBlocks = htmlToDraft(htmlBody);
//   return ContentState.createFromBlockArray({...htmlBlocks}).getPlainText();
// }

export function isMobileApp() {
  return /oncoRecordsMobile/i.test(navigator.userAgent);
}

export const convertUtcTimeToLocal = (utcTime) => {
  return moment(utcTime).add('minutes', moment().utcOffset());
};

export const getMaxIntFromArray = (numbers) => {
  return Math.max.apply(Math.max, numbers);
};

export const arraysAreSame = (newArray, oldArray) => {
  return newArray.every((x) => oldArray.includes(x));
}

export const getGenderFromNumber = (number) => {
	const genders = {
		1: "male",
		2: "female",
		3: "other"
	};

	return genders[number];
};

export const allObjectValuesAreNull = (obj) => {
	return !obj || Object.values(obj).filter(obj => !obj).length === Object.keys(obj).length;
};
export const blobsAreDifferent = (b1, b2) => {
	if (b1 === undefined && b2 === undefined) {
		return false;
	} else if (b1 !== undefined && b2 !== undefined) {
		return b1.size !== b2.size;
	} else if (b1 !== undefined && b2 === undefined){
		return b1.size > 0;
	}
  return b2.size > 0;
};

export const createTemporaryId = () => {
		return Math.random()
			.toString(36)
			.substring(5);
	};

export const replaceObjectInCollection = (collection, newItem, property) => {
	return map(collection, (item) => {
		return item[property] === newItem[property] 
			? newItem
			: item;
	});
};

export const capitilizeFirstLetter = (string) => {
  if (!string) return;
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function mapHealthRecordNameToLocaleKey(hrName) {
  const namesMap = {
    "adverseEffects": "healthRecords.adverse_effects",
    'vitals': "healthRecords.vitals",
    'allergies': "healthRecords.allergies",
    'notes': "healthRecords.notes",
    'labResults': "healthRecords.lab_results",
    'labReports': "healthRecords.lab_reports",
    'labOrders': "healthRecords.lab_orders",
    'medications': "healthRecords.medication",
    'problems': "healthRecords.problems",
    'pain': "healthRecords.pains",
    'reports': "healthRecords.reports",
    'performanceStatus': "healthRecords.performance_status",
    'otherTreatments': "healthRecords.other_treatments",
    'patientDocuments': "healthRecords.patient_documents",
    'chemoSchemes': "healthRecords.chemo_schemes",
    'patientCancerTypes': "healthRecords.patient_cancer_type",
    'ajccStaging': "healthRecords.ajcc_staging",
    'socialAndAddictions': "healthRecords.social_and_addictions",
    'familyHistory': "healthRecords.family_history",
    'prescriptions': "healthRecords.prescriptions",
    'tumorProgress': "healthRecords.tumor_progress",
    'gynecologicalHistory': "healthRecords.gynecology"
  };

  return namesMap[hrName] ?? "";
}

export const getModalStyle = (appView) => {
  let style = { top: ["MobileView", "TabView"].includes(appView) ? 10 : 60, 
    maxWidth: window.innerWidth - 20, // 10: space left + 10: space right
    margin:'0px auto',
    padding: 0,
  };

  return style;
};

export const getModalBodyStyle = async (modalClassName, appView, modalBodyMinHeight) => {
  let modalHeaderHeight = 0;
  let modalFooterHeight = 0;

  if (modalClassName) {
    let modal = document.querySelector(`.${modalClassName}`);

    while (!modal) {
      await new Promise(resolve => setTimeout(resolve, 1)); // Waits for modal to load
      modal = document.querySelector(`.${modalClassName}`);
    }

    const modalHeader = modal.querySelector('.ant-modal-header');
    const modalFooter = modal.querySelector('.ant-modal-footer');
    if (modalHeader) modalHeaderHeight = modalHeader.offsetHeight;
    if (modalFooter) modalFooterHeight = modalFooter.offsetHeight;
  }

  let totalTopAndBottomEmptySpace = 70; // 60: space top + 10: space bottom
  if (["MobileView", "TabView"].includes(appView)) totalTopAndBottomEmptySpace = 20; // 10: space top + 10: space bottom
  const modalBodyMaxHeight = window.innerHeight - modalHeaderHeight - modalFooterHeight - totalTopAndBottomEmptySpace;

  const style = {
    maxHeight: modalBodyMinHeight ? modalBodyMinHeight : modalBodyMaxHeight, // Locks the height in case a modalBodyMinHeight is present
    minHeight: modalBodyMinHeight ? modalBodyMinHeight : MODAL_BODY_MIN_HEIGHT,
    overflow: 'auto',
    paddingBottom: 0,
    display: 'flex'
  };

  return style;
};
